import React from 'react';
import { Link } from '@inertiajs/react';
import useRoute from '@/Hooks/useRoute';

export default function Avatar({
  user,
  displayName = true,
  displayPhoto = true,
  disableLink = false,
}: {
  user: App.Data.UserData;
  displayName?: boolean;
  displayPhoto?: boolean;
  disableLink?: boolean;
}) {
  const route = useRoute();

  if (disableLink) {
    return (
      <div
        className="flex items-center gap-2"
        title={user.name}
      >
        {(user.profile_photo_url && displayPhoto) && (
          <img
            src={user.profile_photo_url}
            alt={user.name}
            className="h-5 w-5 rounded-full object-cover"
          />
        )}
        {displayName && <span>{user.name}</span>}
      </div>
    );
  } else {
    return (
      <Link
        href={route('profile.show', user.id)}
        className="flex items-center gap-2"
        title={user.name}
      >
        {(user.profile_photo_url && displayPhoto) && (
          <img
            src={user.profile_photo_url}
            alt={user.name}
            className="h-5 w-5 rounded-full object-cover"
          />
        )}
        {displayName && <span>{user.name}</span>}
      </Link>
    );
  }
}
